export function isWordOnline(html: string) {
	return /class="(.*)TextRun/.test(html);
}
